import React, {
  ReactNode,
  createContext,
  useCallback,
  useEffect,
  useState,
} from 'react';

type ScrollPosition = [number, number];
const ScrollContext = createContext<ScrollPosition>([0, 0]);
// eslint-disable-next-line import/no-default-export
export default ScrollContext;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const ScrollContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [scroll, setScroll] = useState([0, 0]);
  const handleScroll = useCallback(() => {
    if (window.pageXOffset !== scroll[0] || window.pageYOffset !== scroll[1]) {
      setScroll([window.pageXOffset, window.pageYOffset]);
    }
  }, [scroll]);
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
  return (
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'number[]' is not assignable to type 'ScrollP... Remove this comment to see the full error message
    <ScrollContext.Provider value={scroll}>{children}</ScrollContext.Provider>
  );
};
